import React, { Component } from 'react';
import { safeDeepGet, safeDeepGetWithType } from 'iotera-base/json';
import { isFunction } from 'iotera-base/object';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';
import DashboardIcon from '@material-ui/icons/Dashboard';
import { Tooltip, Zoom } from '@material-ui/core';

import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Collapse from '@material-ui/core/Collapse';
import ChevronRight from '@material-ui/icons/ChevronRight';

import ExpandMore from '@material-ui/icons/ExpandMore';
import IoteraClass from '../react/react-class';

// For Unique Id
const S = '/';

export class NavigationDrawer extends Component {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
    }

    handleClick = (index) => (e) => {
        const handleClick = safeDeepGet(this, ['props', 'handleClick']);
        if (isFunction(handleClick)) {
            handleClick(index, e);
        }
    }

    render() {
        let navList = safeDeepGet(this, ['props', 'navList'], []);
        let classes = safeDeepGet(this, ['props', 'classes'], '');
        let open = safeDeepGetWithType(this, ['props', 'open'], true);
        let location = safeDeepGetWithType(this, ['props', 'location'], S);

        const finalNavs = [];
        for (let i = 0; i < navList.length; i++) {

            let title = safeDeepGetWithType(navList, [i, 'title'], 'Dashboard');
            let to = safeDeepGetWithType(navList, [i, 'to'], S);
            let Icon = safeDeepGetWithType(navList, [i, 'icon'], DashboardIcon);
            let key = safeDeepGetWithType(navList, [i, 'key'], 0);

            finalNavs.push(
                <li key={key} onClick={this.handleClick(key)}
                >
                    <NavLink
                        className={classNames({
                            [classes.ioteraNav]: open,
                            [classes.ioteraNavClose]: !open
                        })}
                        activeClassName={classes.active} to={to}>
                        <span className={classNames({ [classes.iconClose]: !open, [classes.iconOpen]: open })}>
                            <Icon size="8" color={location === to ? "secondary" : "inherit"} style={{ height: 8, width: 8, marginBottom: 5, marginLeft: 5 }} />
                        </span>
                        {open &&
                            <span className={classNames(classes.name, {
                                [classes.tabSelected]: location === to,
                            })}>{title}</span>
                        }
                    </NavLink>
                </li>
            );
        }
        return (
            finalNavs
        )
    }
}

// by devenovil
function createMagicNav(resultNav, navList, classes, open, location, handleClick, isCollapse, state, parentTo, toggleExpand, prefix, isTenant) {
    let innerChild = [];

    let isCollapseOpen = false;

    for (let i = 0; i < navList.length; i++) {
        let currNav = safeDeepGetWithType(navList, [i], {});
        let title = safeDeepGetWithType(currNav, ['label'], 'Dashboard');
        let path = safeDeepGetWithType(currNav, ['path'], S);
        let to = prefix + path;
        let Icon = safeDeepGetWithType(currNav, ['icon'], DashboardIcon);
        let color = location === to ? "#fff" : "#000";
        let colorExpand = location === to ? "#4D2C91" : "#000";
        isCollapseOpen = safeDeepGetWithType(state, [to], false);
        let curNavChild = safeDeepGetWithType(currNav, ['children'], []);

        if (curNavChild.length > 0) {
            if (isCollapse) {
                innerChild.push(
                    <Tooltip TransitionComponent={Zoom} title={title} enterDelay={1000} placement='right' key={to}>
                        <ListItem style={{ padding: 0, marginTop: 4 }}
                        >
                            <span
                                style={{ display: 'flex' }}
                            >
                                {open ?
                                    isCollapseOpen ?
                                        <span className={classNames({ [classes.ioteraCollapseButton]: open })} style={{ marginRight: 0, color: colorExpand }}>
                                            <ExpandMore color='inherit' style={{ height: 16, width: 16, marginBottom: 5, marginRight: 4 }} onClick={toggleExpand(to)} />
                                        </span>
                                        :
                                        <span className={classNames({ [classes.ioteraCollapseButton]: open })} style={{ marginRight: 0, color: colorExpand }}>
                                            <ChevronRight color='inherit' style={{ height: 16, width: 16, marginBottom: 5, marginRight: 4 }} onClick={toggleExpand(to)} />
                                        </span>
                                    : null
                                }
                                <span className={classNames({
                                    [classes.ioteraNav]: open,
                                    [classes.ioteraNavClose]: !open,
                                    [classes.active]: location === to
                                })}
                                    onClick={handleClick(to)}>
                                    {isTenant ?
                                        <span style={{ color: color }} className={classNames({ [classes.iconClose]: !open, [classes.iconOpen]: open })}>
                                            <Icon color='inherit' style={{ height: 16, width: 16, marginLeft: 5 }} />
                                        </span>
                                        : <span style={{ marginLeft: 5 }} />}

                                    {open &&
                                        <span className={classNames(classes.name, {
                                            [classes.tabSelected]: location === to,
                                        })}>{title}</span>
                                    }
                                </span>

                            </span>
                        </ListItem>
                    </Tooltip>
                );
                innerChild.push(
                    <Collapse in={isCollapseOpen} timeout="auto" unmountOnExit key={to + 1}>
                        <List className={classes.listUnstyled}>
                            {createMagicNav(innerChild, curNavChild, classes, open, location, handleClick, true, state, to, toggleExpand, prefix, isTenant)}
                        </List>
                    </Collapse>
                );
            } else {
                resultNav.push(
                    <Tooltip TransitionComponent={Zoom} title={title} enterDelay={1000} placement='right' key={to}>
                        <ListItem style={{ padding: 0, marginTop: 4 }}
                        >
                            <span
                                style={{ display: 'flex' }}
                            >
                                {open ?
                                    isCollapseOpen ?
                                        <span className={classNames({ [classes.ioteraCollapseButton]: open })} style={{ marginRight: 0, color: colorExpand }}>
                                            <ExpandMore color='inherit' style={{ height: 16, width: 16, marginBottom: 5, marginRight: 4 }} onClick={toggleExpand(to)} />
                                        </span>
                                        :
                                        <span className={classNames({ [classes.ioteraCollapseButton]: open })} style={{ marginRight: 0, color: colorExpand }}>
                                            <ChevronRight color='inherit' style={{ height: 16, width: 16, marginBottom: 5, marginRight: 4 }} onClick={toggleExpand(to)} />
                                        </span>
                                    : null
                                }
                                <span className={classNames({
                                    [classes.ioteraNav]: open,
                                    [classes.ioteraNavClose]: !open,
                                    [classes.active]: location === to
                                })}
                                    onClick={handleClick(to)}>
                                    {isTenant ?
                                        <span style={{ color: color }} className={classNames({ [classes.iconClose]: !open, [classes.iconOpen]: open })}>
                                            <Icon color='inherit' style={{ height: 16, width: 16, marginLeft: 5 }} />
                                        </span> : <span style={{ marginLeft: 5 }} />}
                                    {open &&
                                        <span className={classNames(classes.name, {
                                            [classes.tabSelected]: location === to,
                                        })}>{title}</span>
                                    }
                                </span >

                            </span>
                        </ListItem>
                    </Tooltip>
                );
                createMagicNav(resultNav, curNavChild, classes, open, location, handleClick, true, state, to, toggleExpand, prefix, isTenant);
            }

        } else {
            if (isCollapse) {
                innerChild.push(
                    <Tooltip TransitionComponent={Zoom} title={title} enterDelay={1000} placement='right' key={to}>
                        <ListItem onClick={handleClick(to)} style={{ padding: 0, marginTop: 4 }}
                        >
                            <div
                                className={classNames({
                                    [classes.ioteraNav]: open,
                                    [classes.ioteraNavClose]: !open,
                                    [classes.active]: location === to
                                })}
                                style={{ marginLeft: 20 }}
                            >
                                {isTenant ?
                                    <span style={{ color: color }} className={classNames({ [classes.iconClose]: !open, [classes.iconOpen]: open })}>
                                        <Icon color='inherit' style={{ height: 16, width: 16, marginLeft: 5 }} />
                                    </span> : <span style={{ marginLeft: 5 }} />}
                                {open &&
                                    <span className={classNames(classes.name, {
                                        [classes.tabSelected]: location === to,
                                    })}>{title}</span>
                                }

                            </div>
                        </ListItem>
                    </Tooltip>
                );
            } else {
                resultNav.push(
                    <Tooltip TransitionComponent={Zoom} title={title} enterDelay={1000} placement='right' key={to}>
                        <ListItem onClick={handleClick(to)} style={{ padding: 0, marginTop: 4 }}
                        >
                            <div
                                className={classNames({
                                    [classes.ioteraNav]: open,
                                    [classes.ioteraNavClose]: !open,
                                    [classes.active]: location === to
                                })}
                                style={{ marginLeft: 20 }}
                            >
                                {isTenant ?
                                    <span style={{ color: color }} className={classNames({ [classes.iconClose]: !open, [classes.iconOpen]: open })}>
                                        <Icon color='inherit' style={{ height: 16, width: 16, marginLeft: 5 }} />
                                    </span> : <span style={{ marginLeft: 5 }} />}
                                {open &&
                                    <span className={classNames(classes.name, {
                                        [classes.tabSelected]: location === to,
                                    })}>{title}</span>
                                }

                            </div>
                        </ListItem>
                    </Tooltip>
                );
            }

        }

    }

    if (isCollapse) {
        if (innerChild.length > 0) {
            isCollapseOpen = safeDeepGetWithType(state, [parentTo], false);
            resultNav.push(
                <Collapse in={isCollapseOpen} timeout="auto" unmountOnExit style={{ marginLeft: 20 }}>
                    <List className={classes.listUnstyled}>
                        {innerChild}
                    </List>
                </Collapse>
            );
        }
    }

}
export class NavigationDrawerWithTooltip extends IoteraClass {
    constructor(props) {
        super(props);
        this.handleClick = this.handleClick.bind(this);
        this.toggleExpand = this.toggleExpand.bind(this);
    }


    handleClick = (location) => (e) => {
        const handleClick = safeDeepGet(this, ['props', 'handleClick']);

        if (isFunction(handleClick)) {
            handleClick(location);
        }
    }

    toggleExpand = (unique) => (e) => {
        let open = safeDeepGetWithType(this, ['state', unique], false);
        this.setState({
            [unique]: !open,
        });

    }


    render() {
        let navList = safeDeepGet(this, ['props', 'navList'], []);
        let classes = safeDeepGet(this, ['props', 'classes'], '');
        let prefix = safeDeepGet(this, ['props', 'prefix'], '');
        let isTenant = safeDeepGetWithType(this, ['props', 'isTenant'], true);
        let open = safeDeepGetWithType(this, ['props', 'open'], true);
        let location = safeDeepGetWithType(this, ['props', 'location'], S);

        const finalNavs = [];
        createMagicNav(finalNavs, navList, classes, open, location, this.handleClick, false, this.state, null, this.toggleExpand, prefix, isTenant);

        return (
            <div style={{ marginLeft: 20 }}>
                {finalNavs}
            </div>
        )
    }
}